module.exports = __webpack_public_path__ + "d8751050310e1e022aa5ff768a8946be.svg";